import React, {
  RefObject,
  useEffect,
  useMemo,
  useState,
} from 'react';
import {
  useTableReset,
} from 'core/hooks';
import {
  VirtualTableInstance,
} from 'core/components/VirtualTable/types';
import Table from 'core/components/VirtualTable';
import {
  ServiceFacilityDTO,
} from 'dtos';
import {
  getServiceFacilities,
} from 'views/EMR/Settings/transport';
import Section from 'views/EMR/Settings/BillingConfigurations/Section';
import {
  commonTableClasses,
} from 'views/EMR/Settings/BillingConfigurations';
import serviceFacilityColumns from 'views/EMR/Settings/BillingConfigurations/ServiceFacility/columns';
import useUserInfo from 'pages/Dashboard/hooks/useUserInfo';
import ServiceFacilityDialog, {
  ServiceFacilityDialogProps,
} from 'views/EMR/Settings/BillingConfigurations/ServiceFacility/Dialog';
import isNil from 'lodash/isNil';
import {
  settingsEventChannel,
} from 'pages/Dashboard/services/eventChannels';

export default function ServiceFacility() {
  const { tableInstanceRef } = useTableReset();
  const userInfo = useUserInfo();

  const [
    serviceFacilityDialogParams,
    setServiceFacilityDialogParams,
  ] = useState<ServiceFacilityDialogProps | null>(null);

  useEffect(() => {
    const unsubscribeFromServiceFacilityChange = settingsEventChannel.on('onServiceFacilityChange', () => {
      tableInstanceRef?.current?.refetch?.();
    });

    return () => {
      unsubscribeFromServiceFacilityChange();
    };
  }, []);

  const columns = useMemo(() => (
    userInfo?.flags?.mayEditOrgConfiguration
      ? serviceFacilityColumns
      : serviceFacilityColumns.slice(0, -1)
  ), [userInfo]);

  const onAdd = () => {
    setServiceFacilityDialogParams({
      facility: null,
    });
  };

  return (
    <>
      <Section
        headerProps={{
          title: 'Service Facilities',
          onAdd: userInfo?.flags?.mayEditOrgConfiguration ? onAdd : undefined,
          onAddTooltip: 'Add Service Facility',
        }}
      >
        <Table<ServiceFacilityDTO>
          instanceRef={tableInstanceRef as RefObject<VirtualTableInstance>}
          getData={getServiceFacilities}
          getRowId={(row) => row?.serviceFacilityId}
          columns={columns}
          emptySlot="No Service Facilities Found"
          classes={{
            ...commonTableClasses,
            row: '!py-1 !px-2 !items-start ',
          }}
          dataKey="service-facilities"
          onRowClick={(table, row) => {
            if (userInfo?.flags?.mayEditOrgConfiguration) {
              setServiceFacilityDialogParams({
                facility: row?.original,
              });
            }
          }}
        />
      </Section>
      {!isNil(serviceFacilityDialogParams) && (
        <ServiceFacilityDialog
          {...serviceFacilityDialogParams}
          onClose={() => { setServiceFacilityDialogParams(null); }}
        />
      )}
    </>
  );
}
